import React from 'react';
import autoBind from 'react-autobind';
import * as commonActionType from '@common/store/common/common.actionsType';

//Context
import { withGridContext } from './grid.factory';

//Filters
import FilterText from './filters/grid.filter.text';
import FilterDate from './filters/grid.filter.date';
import FilterNumber from './filters/grid.filter.number';
import FilterDecimal from './filters/grid.filter.decimal';
import FilterList from './filters/grid.filter.lista';
import FilterCpfCnpj from './filters/grid.filter.cpfCnpj';
import Form from '@common/components/validation/form.validation';

class GridFilter extends React.Component {
  constructor(props) {
    super(props);

    this.filterRefs = {
      container: React.createRef(),
      icon: React.createRef(),
      filter: React.createRef(),
    };

    autoBind(this);
  }

  updateContextColumn(column, save = true) {
    const { context } = this.props;
    const { columns } = context;
    columns[this.props.index] = column;
    context.setState({ columns }, save);
  }

  componentDidMount() {
    $('html').bind('keydown', (evt) => {
      if (evt.which === 27) {
        this.closeFilters();
      }
    });

    $('html').bind('click', (evt) => {
      var target = $(evt.target);
      if (!target.parents('.btn-filter').length && !target.parents('.filterContainer').length) {
        this.closeFilters();
      }
    });
    $('.wrapper-grid').bind('scroll', () => {
      this.closeFilters();
    });

    PubSub.subscribe(commonActionType.ON_OPEN_FILTER, this.onOpenFilter.bind(this));
  }

  componentDidUpdate() {
    const { form } = this;
    if (form) {
      const { column } = this.props;
      const isValid = _.keys(form.errors).length == 0;

      var filterColunm = document.querySelector('.filterColunm.title');
      if (filterColunm) {
        $('html').bind('click', (evt) => {
          var target = $(evt.target);
          if (!target.parents('.btn-filter').length && !target.parents('.filterContainer').length) {
            this.closeFilters();
          }
        });
      }

      if (column.isValid !== isValid) {
        column.isValid = isValid;
        this.updateContextColumn(column, false);
      }
    }
  }

  trimTextFilter() {
    const { context } = this.props;
    const { columns } = context;

    columns.forEach(function (x) {
      if (x.type == 'text') {
        x.inputs.forEach(function (y) {
          y.value = y.value ? y.value.trim() : y.value;
        });
      }
    });

    context.setState({ columns }, false);
  }

  closeFilters() {
    const { context } = this.props;
    const { columns } = context;
    if (columns.some((x) => x.isOpenFilter)) {
      columns.forEach((column) => {
        column.isOpenFilter = false;
      });
      context.setState({ columns }, false);
    }
  }

  onOpenFilter(action, data) {
    const { hash } = this.props.context;
    const closeFilters = this.closeFilters;
    if (data != hash) {
      $(document).click(function (e) {
        if (!$(e.target).is('ul.filter.filterContainer.filterBody')) {
          closeFilters();
        }
      });
    }
  }

  getFilterIconBounds() {
    const filterIcon = this.filterRefs.icon.current;
    if (!filterIcon) return { left: 0, top: 0 };
    return filterIcon.getBoundingClientRect();
  }

  get getX() {
    const { column } = this.props;
    const { isAdvancedSearch } = column;

    let bounds = this.getFilterIconBounds();
    var x = bounds.left + window.scrollX + 10;
    if (x > document.body.offsetWidth - 258) {
      x = x - (isAdvancedSearch ? 386 : 258);
    }
    return x;
  }

  get getY() {
    let bounds = this.getFilterIconBounds();
    return bounds.top + window.scrollY + 10;
  }

  async openFilter() {
    PubSub.publish(commonActionType.ON_OPEN_FILTER, this.props.context.hash);

    $('body').prepend(this.filterRefs.container.current);
    const { context } = this.props;
    const { columns } = context;
    columns.forEach((column, index) => {
      column.isOpenFilter = index == this.props.index;
    });
    await context.setState({ columns }, false);
    $(this.filterRefs.container.current).find('input').first().focus();
  }

  async onSubmitFilter() {
    const { context } = this.props;
    this.trimTextFilter();
    this.closeFilters();
    const filter = this.filterRefs.filter.current;
    filter.onSubmit && filter.onSubmit();
    if (!filter.isValid || (await filter.isValid())) context.setStateAndRefresh({ pageNumber: 1 });
  }

  stopPropagation(e) {
    e.stopPropagation();
    if (e.nativeEvent) e.nativeEvent.stopImmediatePropagation();
  }

  render() {
    const { column } = this.props;
    const { isFiltered, isAdvancedSearch, isOpenFilter, isInvalid } = column;

    return (
      <div className="dropdown btn-filter" onClick={this.stopPropagation}>
        {
          <>
            <a className="btn-custom dropdown-toggle" onClick={this.openFilter}>
              <i
                ref={this.filterRefs.icon}
                name={column.fieldName}
                className={`fa fa-filter ${isFiltered ? 'filtered' : ''}`}
                title={'Filtro'}
              />
            </a>
            <ul
              ref={this.filterRefs.container}
              className={`filter filterContainer ${isAdvancedSearch ? 'advanced-search-container' : ''} ${
                isOpenFilter ? 'filterBody' : ''
              }`}
              style={{ display: isOpenFilter ? 'block' : 'none', left: this.getX, top: this.getY }}
            >
              <li>
                <Form onSubmitFilter={this.onSubmitFilter} shouldUpdate={true}>
                  {(form) => (
                    <div>
                      <h2 className="filterColunm title">{column.fieldName}</h2>
                      {this.renderFilter(column, form)}

                      <div className="float-right">
                        <button type="button" className="btn btn-primary" onClick={form.handleSubmit}>
                          Aplicar
                        </button>
                      </div>
                    </div>
                  )}
                </Form>
              </li>
            </ul>
          </>
        }
      </div>
    );
  }

  renderFilter(column, form) {
    const { props } = this;
    this.form = form;
    switch (column.type) {
      case 'text':
        return <FilterText ref={this.filterRefs.filter} {...props} />;
      case 'date':
        return <FilterDate ref={this.filterRefs.filter} {...props} />;
      case 'number':
        return <FilterNumber ref={this.filterRefs.filter} {...props} />;
      case 'decimal':
        return <FilterDecimal ref={this.filterRefs.filter} {...props} />;
      case 'lista':
        return <FilterList ref={this.filterRefs.filter} {...props} />;
      case 'cpfCnpj':
        return <FilterCpfCnpj ref={this.filterRefs.filter} {...props} />;
      default:
        return <FilterText ref={this.filterRefs.filter} {...props} />;
    }
  }
}

export default withGridContext(GridFilter);
